export const APP_VERSION = 'V5.03.05';
export const APP_VERSION_STORAGE_KEY = 'app_version';
